<template>
  <v-dialog
    v-model="show"
    width="350px"
    max-width="100%"
    max-height="90vh"
    content-class="warning-modal"
  >
    <template #activator="{ props }">
      <v-btn
        variant="flat"
        icon
        class="information-button"
        size="small"
        :ripple="false"
        v-bind="props"
        data-png-remove
      >
        <ExclamationCircleIcon />
      </v-btn>
    </template>
    <v-card
      width="350px"
      max-width="100%"
      max-height="90vh"
    >
      <v-card-title>
        <div class="card-title-container">
          <div class="card-title-inner-container">
            <h5>Warning</h5>
            <v-btn
              variant="flat"
              size="small"
              icon
              @click="show = false"
            >
              <v-icon
                color="iconDefault"
                size="18px"
                icon="$close"
              />
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="content">
          <slot name="prepend:content" />
          <div
            class="content-text"
          >
            <DpplSafeHtml :html="contentHtml" />
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="hasActionSlot">
        <slot name="action" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'pinia';
import { useTooltips } from '@/stores/insights/tooltips';
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';
import ExclamationCircleIcon from '@/assets/icon-exclamation-mark.svg?component';

export default {
  name: 'WarningWithModal',
  components: {
    DpplSafeHtml,
    ExclamationCircleIcon,
  },
  props: {
    textKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState(useTooltips, ['tooltips']),
    hasActionSlot() {
      return !!this.$slots.action;
    },
    contentHtml() {
      const { body_r: html } = this.tooltips?.[this.textKey] || {};

      return html || '';
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes blink {
  from {
    transform: scale(0.5);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0;
  }
}

.v-btn.information-button {
  cursor: pointer;
  max-width: 18px;
  max-height: 18px;

  &:hover :deep(.v-btn__overlay) {
    background: @white;
  }
}

.v-btn.information-button::before {
  background-color: @basic-yellow;
  content: '';
  position: absolute;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  right: -5px;
  bottom: -5px;
  opacity: 0;
  animation: blink 1s infinite;
  transition: ease-in-out;
}
</style>

<style lang="less">
.warning-modal .v-card {
  .v-card-title {
    padding: 0;
  }

  .v-card-text {
    padding: 8px 24px 24px !important;
    letter-spacing: normal !important;
  }

  .v-card-actions {
    padding: 0 24px 24px 8px;

    .v-btn__content {
      letter-spacing: normal !important;
    }
  }

  .card-title-container {
    width: 100%;
    height: 68px;
    border-bottom: 1px solid @stroke-default;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }

  .card-title-inner-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px;
  }

  .content {
    text-align: left;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
  }
}
</style>
